import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { cashService } from '../../services/cashService';

export const useCheckIbanNumber = (payload, options = {}) => {
  return useQuery({
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    queryKey: [QUERY_KEYS.cash.check_iban_number, payload],
    queryFn: () =>
      cashService
        .checkIbanNumber(payload)
        .then(response => {
          const { status, data } = response;
          if (status === 200) {
            return data;
          }
          return null
        }),
    ...options,
  });
};
